import { createSlice } from '@reduxjs/toolkit';

export const eventSlice = createSlice({
    name: 'event',
    initialState: null,
    reducers: {
        eventSet: (state, action) => {
            return action.payload;
        }
    }
});

export const { eventSet } = eventSlice.actions;
export default eventSlice.reducer;
